import { createRoutine } from 'redux-saga-routines'

import { ChangePassword } from './constants'
import { IChangePasswordState } from './index.interface'
const initialLoginState: IChangePasswordState = {
  loading: false,
  error: false,
  success: false,
  message: ''
}

export const updatePassword = createRoutine(ChangePassword)

export default (state = initialLoginState, action: any) => {
  switch (action.type) {
    case updatePassword.TRIGGER:
      return {
        ...state,
        error: false,
        loading: true,
        success: false,
        message: ''
      }
    case updatePassword.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: ''
      }
    case updatePassword.FAILURE:
      return {
        ...state,
        error: true,
        loading: false,
        success: false,
        message: action.payload
      }
    default:
      return { ...state }
  }
}
